import { Button } from '@gto/ui/button'
import { cn } from '@gto/ui/cn'

import { SubscriptionKind, SubscriptionKindEnum } from '@/pages/rewards/constants'

export type GtoSubscriptionsSwitcherProps = {
  active: SubscriptionKindEnum
  onClick: (kind: SubscriptionKindEnum) => void
}

export const GtoSubscriptionsSwitcher = ({ active, onClick }: GtoSubscriptionsSwitcherProps) => {
  return (
    <div className="flex gap-4 overflow-x-auto">
      {SubscriptionKind.map((type) => {
        return (
          <Button
            key={SubscriptionKindEnum[type]}
            size="large"
            variant="outlined"
            className={cn(
              'flex-[1_0_auto] grow border-divider bg-paper-elevation2 text-text-primary',
              SubscriptionKindEnum[type] === active &&
                'border-primary-main bg-paper-elevation0 text-primary-main',
            )}
            onClick={() => {
              onClick(SubscriptionKindEnum[type])
            }}
          >
            {type}
          </Button>
        )
      })}
    </div>
  )
}
